import React from 'react'
import image2 from "../image/image2.png";
import { FaFileAlt, FaBook, FaGlobeAmericas, FaChartLine, FaRegNewspaper } from "react-icons/fa";
import { HiOutlineArrowRight } from "react-icons/hi";
import { Link } from "react-router-dom";

const Policyweek = () => {
  return (
    <div>
      {/* ================= POLICY ADVOCACY OF THE WEEK ================= */}
      <section
        className="relative bg-cover bg-center bg-no-repeat py-20 scroll-mt-[130px]" id="policy"
        style={{ backgroundImage: `url(${image2})` }}
      >
        {/*<div className="absolute inset-0 bg-gradient-to-r from-blue-900/10 to-blue-800/50"></div>*/}
        
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-3 gap-10">
            
            {/* ================= LEFT CONTENT ================= */}
            <div className="lg:col-span-2 space-y-6">
              {/* Section Header */}
              <div className="mb-8">
                <div className="inline-flex items-center gap-2 mb-2">
                  <div className="w-10 h-10 rounded-full bg-gradient-to-r from-blue-900 to-blue-700 flex items-center justify-center">
                    <FaFileAlt className="text-white text-xl" />
                  </div>
                  <h2 className="lg:text-3xl text-2xl font-bold text-blue-900">
                    Policy <span className="text-orange-500 italic">Advocacy of the Week</span>
                  </h2>
                </div>
                <p className="text-blue-900 text-lg">
                  Highlighting key policy discussions and research initiatives
                </p>
              </div>

              {/* Policy Brief */}

          <div className="bg-white/95 backdrop-blur-sm p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                <div className="flex gap-4">
                  <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center flex-shrink-0">
                    <FaFileAlt className="text-orange-600 text-xl" />
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-orange-600">
                      CM Health Fellows:  A Replicable Human Resource for Health (HRH) Reform Model for Hard-to-Reach India
                    </h4>
                    <p className="text-slate-600 mt-3 leading-relaxed">
                Uttar Pradesh has embarked upon an innovative Universal Health Coverage (UHC) outreach - public 
                health governance with the launch of the “U.P. CM Health Fellows”. It has huge global significance 
                for reducing Global Burden of Disease (GBD) and enriching Demographic Dividend, and it redefines
                 how India approaches rural health delivery. 
                    </p>
                    <Link to='/policybrief2'>
                    <div className="mt-4 flex items-center text-blue-900 font-medium">
                      <span className="text-sm">Read Full Brief</span>
                      <HiOutlineArrowRight className="ml-2" />
                    </div>
                    </Link>
                  </div>
                </div>
              </div>


              <div className="bg-white/95 backdrop-blur-sm p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                <div className="flex gap-4">
                  <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center flex-shrink-0">
                    <FaFileAlt className="text-blue-900 text-xl" />
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-blue-900">
                      Policy Brief: Global MedTech Stakeholder Policy Playbook for Smarter, Lower Burden Regulation
                    </h4>
                    <p className="text-slate-600 mt-3 leading-relaxed">
                   An international policy playbook should function as a shared reference document
                    for innovators, manufacturers, academia, regulators, patient groups and digital 
                    health organizations, guiding how they collectively shape smart regulation for 
                    disruptive MedTech
                    </p>
                     <Link to='/policybrief'>
                    <div className="mt-4 flex items-center text-orange-600 font-medium">
                      <span className="text-sm">Read Full Brief</span>
                      <HiOutlineArrowRight className="ml-2" />
                    </div>
                    </Link>
                  </div>
                </div>
              </div>
                
                <div className="bg-white/95 backdrop-blur-sm p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                <div className="flex gap-4">
                  <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center flex-shrink-0">
                    <FaFileAlt className="text-orange-600 text-xl" />
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-orange-600">
                      Policy Brief: De-Risking Healthcare Supply Chains in a VUCA World
                    </h4>
                    <p className="text-slate-600 mt-3 leading-relaxed">
                 The global healthcare ecosystem is operating in an era defined by VUCA—Volatility, 
                 Uncertainty, Complexity, and Ambiguity. From pandemics and geopolitical tensions to 
                 climate-induced disruptions and trade realignments, healthcare supply chains—particularly 
                 those supporting medical technology (MedTech)—have been repeatedly stress-tested.
                    </p>
                    <Link to='/policybrief1'>
                    <div className="mt-4 flex items-center text-blue-900 font-medium">
                      <span className="text-sm">Read Full Brief</span>
                      <HiOutlineArrowRight className="ml-2" />
                    </div>
                    </Link>
                  </div>
                </div>
              </div>
              

              {/* Recommendations 
              <div className="bg-white/95 backdrop-blur-sm p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                <div className="flex gap-4">
                  <div className="w-12 h-12 rounded-full bg-orange-50 flex items-center justify-center flex-shrink-0">
                    <FaChartLine className="text-orange-500 text-xl" />
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-orange-500">
                      Recommendations: De-Risking Healthcare Supply Chains in a VUCA World
                    </h4>
                    <p className="text-slate-600 mt-3 leading-relaxed">
                      Strategic recommendations for strengthening disease surveillance
                      systems through technology integration and multi-stakeholder
                      collaboration.
                    </p>
                    <div className="mt-4 flex items-center text-orange-500 font-medium">
                      <span className="text-sm">View Recommendations</span>
                      <HiOutlineArrowRight className="ml-2" />
                    </div>
                  </div>
                </div>
              </div> */}

              {/* Research Paper */}
              <div className="bg-white/95 backdrop-blur-sm p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                <div className="flex gap-4">
                  <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center flex-shrink-0">
                    <FaBook className="text-blue-900 text-xl" />
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-blue-900">
                      Global Public Health Emergencies: Insights for Future Preparedness
                    </h4>
                    <p className="text-slate-600 mt-3 leading-relaxed">
                      Based on India’s response to the COVID-19 pandemic
                    </p>
                    <p className="text-slate-600 mt-3 leading-relaxed"><strong>Author: </strong>Dr. Urvashi Prasad
<br/>Public Health & Policy Specialist; Former Director, Office of Vice Chairperson, NITI Aayog, Government of India</p>
                    <div className="mt-4 flex items-center text-orange-600 font-medium">
                       <a
              href="https://9vom.in/journals/index.php/gshj/article/view/475"
              target="_blank"
              rel="noopener noreferrer"
              className="text-orange-600 font-semibold hover:underline"
            >
              Click here to read full article →
            </a>
                     {/* <span className="text-sm">Click here to read full article</span>
                      <HiOutlineArrowRight className="ml-2" />*/}
                    </div>
                  </div>
                </div>
              </div>

              <Link
                to="/policy-dialogues"
                className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-900 to-blue-700 text-white px-8 py-3 rounded-full hover:from-blue-800 hover:to-blue-600 transition-all duration-300 hover:shadow-lg mt-4 font-semibold"
              >
                View All Dialogues
                <HiOutlineArrowRight />
              </Link>
            </div>

            {/* ================= RIGHT STATS ================= */}
            <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-xl p-8 text-center self-start lg:mt-24">
              <div className="mb-6">
                <h3 className="text-2xl font-bold text-blue-900 mb-2">
                  G<sup>d</sup>PhD’s Milestones (Outcomes) for 2026-2027 
                </h3>
                <p className="text-slate-600 text-sm">
                  Our reach and influence in health policy advocacy
                </p>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                <div className="text-center">
                  <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center mx-auto mb-3">
                    <FaGlobeAmericas className="text-blue-900 text-2xl" />
                  </div>
                  <h3 className="text-3xl font-bold text-blue-900">50+</h3>
                  <p className="text-sm text-slate-600 mt-1">Countries Outreach</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 rounded-full bg-orange-50 flex items-center justify-center mx-auto mb-3">
                    <FaChartLine className="text-orange-500 text-2xl" />
                  </div>
                  <h3 className="text-3xl font-bold text-blue-900">100+</h3>
                  <p className="text-sm text-slate-600 mt-1">Global Healthcare Experts Engagement</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center mx-auto mb-3">
                    <FaFileAlt className="text-blue-900 text-2xl" />
                  </div>
                  <h3 className="text-3xl font-bold text-blue-900">50+</h3>
                  <p className="text-sm text-slate-600 mt-1">Policy Recommendations</p>
                </div>
              </div>

              <Link
                to="/publications"
                className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-500 to-orange-400 text-white px-8 py-3 rounded-full hover:from-orange-600 hover:to-orange-500 transition-all duration-300 hover:shadow-lg font-semibold"
              >
                View All Publications
                <HiOutlineArrowRight />
              </Link>
            </div>
          </div>
        </div>
      </section>






     {/* ================= HEALTHCARE DYNAMICS & ECONOMICS ================= */}
<section className="max-w-7xl mx-auto px-6 py-16">
  
  {/* ================= SECTION HEADER ================= */}
  <div className="text-center mb-14">
    <h2 className="text-3xl md:text-4xl font-bold text-blue-900">
      Healthcare Dynamics & Economics Updates
      <span className="text-orange-500">: India & World</span>
    </h2>
    <p className="text-slate-600 mt-3 max-w-3xl mx-auto">
      Key policy movements, economic signals, and health system developments
      shaping healthcare landscapes in India and globally.
    </p>
  </div>

  {/* ================= INDIA & WORLD GRID ================= */}
  <div className="grid lg:grid-cols-2 gap-12">

    {/* ================= INDIA COLUMN ================= */}
    <div className="bg-white rounded-2xl shadow-xl p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-full bg-gradient-to-r from-blue-900 to-blue-700 flex items-center justify-center">
          <FaRegNewspaper className="text-white" />
        </div>
        <h3 className="text-2xl font-bold text-blue-900">India</h3>
      </div>

      <ul className="space-y-4 text-slate-700 text-sm leading-relaxed">
        <li><strong>India’s improved standing in global pharmacovigilance: </strong>India has moved up significantly in the World Health Organization’s pharmacovigilance rankings, rising from 123rd to 8th place worldwide. This reflects stronger systems for monitoring drug safety and the expansion of quality standards under the Indian Pharmacopoeia 2026. </li>
        <li><strong>Recognition for Ayushman Bharat implementation: </strong>Uttar Pradesh received a national award for effective implementation of the Ayushman Bharat scheme, particularly for efficient claim processing and grievance resolution. This highlights improved access to healthcare for economically vulnerable populations. </li>
        <li><strong>Advances in health system performance: </strong>Recent health data show sharp declines in tuberculosis, malaria, and maternal mortality in India, with progress outpacing global averages. These trends indicate the strengthening of public health programs across the country. </li>
        <li><strong>Policy initiatives to improve hospital services:  </strong>The Telangana government is planning to revamp its Integrated Hospital Facility Management System to enhance sanitation, staffing, and support services in public hospitals.</li>
        <li><strong>Emphasis on non-communicable diseases and health equity: </strong>A high-level discussion organised by The George Institute stressed the need to translate research into policy action to address non-communicable diseases, which account for over 65% of deaths in India, and to advance universal health coverage. </li>
        <li><strong>Proposed regulation of health insurance claims: </strong>The government is considering tighter oversight of the National Health Claims Exchange, which connects hospitals and insurers. Joint supervision with the finance ministry and insurance regulator aims to curb overcharging and improve the affordability of health insurance. </li>
        <li><strong>Trends in healthcare costs: </strong>Medical plan costs in India are projected to rise by around 11.5% in 2026, exceeding the global average. This increase is largely driven by the growing burden of chronic diseases and rising costs of technology and treatment.</li>
        <li><strong>Expansion of primary care and digital health initiatives: </strong>Ayushman Bharat Health and Wellness Centres, along with digital platforms such as ABHA and teleconsultation services, continue to expand screening for conditions like hypertension and diabetes, as well as immunisation coverage, helping to reduce disease burden and improve access to care.</li>
        <li><strong>Strong deal flow in pharma & healthcare in 2025: </strong>The Indian pharma and healthcare sector saw about $3.5 billion in deals in Q3 2025, driven by strategic acquisitions and investor interest. Notably, Torrent Pharma’s $1.4 billion stake buy in JB Chemicals was among the standout transactions reflecting renewed confidence in sector consolidation and growth opportunities.</li>
      </ul>
    </div>

    {/* ================= WORLD COLUMN ================= */}
    <div className="bg-white rounded-2xl shadow-xl p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-full bg-gradient-to-r from-orange-500 to-orange-400 flex items-center justify-center">
          <FaGlobeAmericas className="text-white" />
        </div>
        <h3 className="text-2xl font-bold text-blue-900">World</h3>
      </div>

      <ul className="space-y-4 text-slate-700 text-sm leading-relaxed">
        <li><strong>WHO Traditional Medicine Summit in New Delhi:  </strong>At a global summit convened by the WHO, representatives from over 100 countries agreed to strengthen research, regulation, and the integration of safe, evidence-based traditional medicine into health systems. The initiative aims to support responses to non-communicable diseases and reduce inequities in healthcare access. </li>
        <li><strong>US health funding commitment in Africa:  </strong>The United States announced a pledge of USD 480 million in health funding for Côte d’Ivoire, supporting programmes in HIV, malaria, maternal and child health, and health security. This reflects evolving global health partnerships based on shared investment. </li>
        <li><strong>Challenges in global health financing: </strong>A recent report highlights that 2025 has been a challenging year for global health, with reductions in development aid placing strain on health systems in low-income countries. Under the Belém Health Action Plan, global philanthropic organisations pledged over USD 300 million for climate and health research, focusing on heat stress, extreme weather impacts, and strengthening health system resilience.</li>
        <li><strong>Global shortages in nursing and midwifery: </strong>According to WHO estimates, the world faces a shortfall of approximately 4.5 million nurses and 0.31 million midwives, a gap that could significantly affect service delivery and emergency response capacity (WHO). </li>
        <li><strong>Rising global mental health burden: </strong>More than one billion people worldwide are estimated to be living with a mental health condition, prompting urgent calls to scale up services and address unmet mental health needs (WHO).</li>
        <li><strong>U.S. & Ivory Coast health partnership:  </strong> The United States committed $480 million in a new global health funding deal with Côte d’Ivoire to support HIV, malaria, maternal and child health, and health security programmes. The pact emphasises shared investment and self-reliance rather than traditional aid models.</li>
        <li><strong>Consumer health merger:  </strong>Kimberly-Clark announced its acquisition of Kenvue, the maker of brands such as Tylenol and Johnson’s, forming a $32 billion global health and wellness business that combines major consumer healthcare portfolios.</li>
      </ul>
       <div className='text-center mt-[16px] font-bold text-xl text-orange-600'>
      <h1>Ongoing Policy Developments</h1>
      <p className='text-blue-900 font-bold text-base'>WHO Pandemic Preparedness Framework:
      <br/><em className='text-sm'>The WHO Pandemic Agreement (WHOPA) continues to guide international 
      coordination on pandemic prevention, preparedness, equity, and response, although implementation and adoption are still evolving.</em>
      </p>
    </div>
    </div>
   
  </div>

  {/* ================= CENTER BUTTON ================= */}
  <div className="flex justify-center mt-14">
    <Link
      to="/events"
      className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-900 to-blue-700 text-white px-10 py-4 rounded-full font-semibold hover:from-blue-800 hover:to-blue-600 transition-all duration-300 shadow-lg"
    >
      View Events & Media
      <HiOutlineArrowRight />
    </Link>
  </div>
</section>

    </div>
  )
}

export default Policyweek;